export const isMobileScreen = (): boolean => {
    return window?.innerWidth < 768;
};
